import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import React, { Component } from 'react'

class ValidityErrorDialog extends Component {
  handleSaveClick = () => {
    this.props.onSave()
    this.props.onClose()
  }

  handleShowErrorsClick = () => {
    this.props.onShowErrors()
    this.props.onClose()
  }

  render() {
    return (
      <Dialog open={this.props.isError}>
        <DialogTitle>{'Wykryliśmy błędy w e-Sprawozdaniu'}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Jeśli zapiszesz takie sprawozdanie do pliku XML i zechcesz je wysłać
            drogą elektroniczną, prawdopodobnie zostanie ono odrzucone przez
            serwer. Zalecamy więc poprawienie błędów.
          </DialogContentText>
          <br />
          <DialogContentText>
            Możesz jednak zapisać sprawozdanie do pliku, by w przyszłości wrócić
            do jego edycji.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleShowErrorsClick} color="primary">
            POKAŻ BŁĘDY
          </Button>
          <Button onClick={this.handleSaveClick} color="primary">
            POBIERZ
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default ValidityErrorDialog
